// ======frontend/src/Supporters.js
import { Link } from 'react-router-dom'

const SUPPORTERS = [
  { img: './images/supporters/M_MANOUCHEKA.png', name: 'A. Manoucheka' },
  { img: './images/supporters/B_DANA.png', name: 'B. Dana' },
  { img: './images/supporters/C_CARLOS.png', name: 'C. Carlos' },
  { img: './images/supporters/R_FLORE.png', name: 'R. Flore' },
  { img: './images/supporters/B_ERIC.png', name: 'B. Eric' },
  { img: './images/supporters/D_CIENDY.png', name: 'D. Ciendy' },
  { img: './images/supporters/G_EVENS.png', name: 'A. Ceide' },
  { img: './images/supporters/2.jpeg', name: 'JP. Jeffson' },
  { img: './images/supporters/1.jpeg', name: 'M. Aleks' },
  { img: './images/supporters/3.jpeg', name: 'D. Mansi' },
  { img: './images/supporters/4.jpeg', name: 'B. Mark' },
  { img: './images/supporters/B_Bernardo.png', name: 'B. Bernardo' },
  { img: './images/supporters/B_Brian.png', name: 'B. Brian' },
  { img: './images/supporters/B_Alcide.png', name: 'B. Alcide' },
  { img: './images/supporters/5.jpeg', name: 'A. Justin' },
];

function Supporters() {
  return (
    // ========Start Join
    <div>
      <style>{`
        .supporters-wrap {
          position: relative;
        }

        /* Edge fade hints that the row scrolls, instead of the content
           just abruptly cutting off at the container edge. */
        .supporters-wrap::before,
        .supporters-wrap::after {
          content: '';
          position: absolute;
          top: 0;
          bottom: 14px;
          width: 36px;
          z-index: 2;
          pointer-events: none;
        }
        .supporters-wrap::before {
          left: 0;
          background: linear-gradient(90deg, #ffffff, rgba(255, 255, 255, 0));
        }
        .supporters-wrap::after {
          right: 0;
          background: linear-gradient(270deg, #ffffff, rgba(255, 255, 255, 0));
        }

        .supporters-scroll {
          display: flex;
          overflow-x: auto;
          gap: 26px;
          padding: 10px 8px 16px;
          -webkit-overflow-scrolling: touch;
          scroll-snap-type: x proximity;
          justify-content: center;
        }
        .supporters-scroll::-webkit-scrollbar { height: 6px; }
        .supporters-scroll::-webkit-scrollbar-thumb {
          background: rgba(184, 132, 46, 0.25);
          border-radius: 6px;
        }

        .supporter-item {
          flex: 0 0 auto;
          width: 92px;
          text-align: center;
          scroll-snap-align: start;
          opacity: 0;
          animation: supporterFadeUp .5s ease forwards;
        }

        .supporter-avatar {
          position: relative;
          width: 74px;
          height: 74px;
          margin: 0 auto 10px;
          border-radius: 50%;
          border: 1px solid #EAA00A;
          padding: 3px;
          transition: transform .2s ease, box-shadow .2s ease;
        }
        .supporter-item:hover .supporter-avatar {
          transform: translateY(-4px) scale(1.06);
          box-shadow: 0 10px 20px -8px rgba(184, 132, 46, 0.55);
        }
        .supporter-avatar img {
          width: 100%;
          height: 100%;
          border-radius: 50%;
          object-fit: cover;
          display: block;
        }
        .supporter-badge {
          position: absolute;
          bottom: -1px;
          right: -1px;
          width: 20px;
          height: 20px;
          border-radius: 50%;
          background: #B8842E;
          color: #fff;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 10px;
          border: 1px solid #fff;
        }

        .supporter-name {
          font-size: 13px;
          font-weight: 600;
          color: #1c1c1e;
          line-height: 1.3;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          transition: color .15s ease;
        }
        .supporter-item:hover .supporter-name { color: #B8842E; }

        @keyframes supporterFadeUp {
          from { opacity: 0; transform: translateY(10px); }
          to { opacity: 1; transform: translateY(0); }
        }

        @media (max-width: 768px) {
          .supporters-scroll { justify-content: flex-start; gap: 18px; }
          .supporter-item { width: 78px; }
          .supporter-avatar { width: 62px; height: 62px; margin-bottom: 8px; }
          .supporter-badge { width: 17px; height: 17px; font-size: 8.5px; }
          .supporter-name { font-size: 11.5px; }
          .supporters-wrap::before, .supporters-wrap::after { width: 24px; }
        }

        @media (max-width: 420px) {
          .supporter-item { width: 70px; }
          .supporter-avatar { width: 54px; height: 54px; }
          .supporter-name { font-size: 10.5px; }
        }
      `}</style>

      <div className="support_home py-4">
        <div className="supporters-wrap">
          <div className="supporters-scroll">
            {SUPPORTERS.map((s, i) => (
              <div className="supporter-item" style={{ animationDelay: `${i * 0.04}s` }} key={s.name}>
                <div className="supporter-avatar">
                  <img src={s.img} alt={s.name} loading="lazy" />
                  <span className="supporter-badge">
                    <i className="bi bi-check-lg"></i>
                  </span>
                </div>
                <div className="supporter-name">{s.name}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
    // ========End header
  )
}

export default Supporters
